<template>
  <v-card>
    <v-card-title>
      <span class="font-weight-bold mr-1">Orientações importantes |</span> Desafio {{ cycle.cycle_name }} - {{ cycle.challenge.count_questions }} questões em {{ cycle.challenge_minutes }} minutos
    </v-card-title>  
    <v-divider class="m-0" />
    <v-card-text>
      <div class="p-3 pt-md-4 pt-5 text-black">
        <v-container fluid>
          <v-row>
            <v-col class="p-0">
              <p class="font-weight-bold">
                Olá! Você está prestar a iniciar o desafio deste ciclo de estudos. O desafio consiste em uma avaliação com questões de todos os
                módulos que você estudou neste ciclo. Antes de iniciar, leia estas informações importantes:
              </p>
              <ol class="pl-3 mb-md-3 mb-4">
                <li class="pb-2">
                  O tempo total do desafio depende do número de módulos do seu ciclo. Caso sejam 3 módulos, você terá 90 minutos. Caso sejam 2 módulos, você terá 60 minutos. Caso sejam 4 módulos, você terá 120 minutos;
                </li>
                <li class="pb-2">
                  O tempo total do desafio depende do número de módulos do seu ciclo. Caso sejam 3 módulos, você terá 90 minutos. Caso sejam 2 módulos, você terá 60 minutos. Caso sejam 4 módulos, você terá 120 minutos.
                </li>
                <li class="pb-2">
                  <span class="font-weight-bold">Você não poderá pausar o cronômetro e voltar ao desafio depois.</span> Por isso, certifique-se que este é o momento ideal para realizar sua avaliação;
                </li>
                <li class="pb-2">
                  Caso tenha algum problema com sua rede ou com a plataforma durante a realização da prova, comunique à sua escola o mais rápido possível;
                </li>
                <li class="pb-2">
                  Você responderá questões apenas dos assuntos dos módulos estudados. Elas estarão agrupadas por área do conhecimento, assim como o ENEM;
                </li>
                <li class="pb-2 ">
                  <span class="font-weight-bold">Você deverá responder TODAS as questões da prova antes de finalizar;</span>
                </li>
                <li class="pb-2">
                  O seu resultado completo poderá ser visualizado ou ao final do desafio ou ao final do ciclo, de acordo com a configuração definida pela sua escola.
                </li>
              </ol>
              <p>
                Esteja atento(a) e boa prova!
              </p>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
    <v-divider class="m-0" />
    <v-card-actions class="d-flex justify-content-md-end justify-content-between">
      <v-btn
        outlined
        class="border-nitro mt-3"
        @click="cancel()"
      >
        <span class="first-letter-capitalize nitro--text">
          Cancelar
        </span>
      </v-btn>
      <v-btn
        color="nitro"
        class="ml-0 ml-md-2 ml-lg-2 white--text mt-3"
        @click="start()"
      >
        <span class="first-letter-capitalize">
          Iniciar desafio
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
  props: {
    cycle: {
      type: Object,
      required: true,
    },
  },
  computed:{
    ...mapState(['challenge']),
  },
  methods: {
    ...mapActions(['startChallenge','isLoading']),
    start() {
      this.isLoading(true);
      this.startChallenge({ id: this.cycle.challenge.id })
      .then(() => {
         this.$router.push({ name: 'challenge.index', params: { challenge_id: this.cycle.challenge.id } })
      })
      .finally(() => {
        this.isLoading(false);
      });
    },
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>

